import { Grid, Typography } from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

export type AlarmAccordionProps = {
    title: string,
    children: React.ReactNode,
    showDetails: boolean,
    toggleDetails: () => void,
    removeBorderBottom?: boolean
}

export default function AlarmAccordion(props: AlarmAccordionProps) {
    const { children, title, showDetails, toggleDetails, removeBorderBottom } = props

    return (
        <Grid
            container
        >
            <Grid xs={12} sx={{ paddingRight: removeBorderBottom ? "23px" : "32px", display: "flex", flexDirection: "row", justifyContent: "space-between", marginBottom: removeBorderBottom ? undefined : "16px", marginTop: removeBorderBottom ? undefined : "0px", borderBottom: removeBorderBottom ? undefined : "1px", borderBottomColor: removeBorderBottom ? undefined : "#94A1AE", borderBottomStyle: removeBorderBottom ? undefined : "solid", cursor: "pointer" }} onClick={toggleDetails}>
                <Typography
                    sx={{
                        fontSize: { xs: "13px", sm: "16px" },
                        width: "50%",
                        textAlign: "left",
                        marginBottom: removeBorderBottom ? "4px" : "16px",
                        marginLeft: removeBorderBottom ? "14px" : "23px",
                    }}
                >
                    {title}
                </Typography>
                <KeyboardArrowRightIcon
                    sx={{
                        marginBottom: removeBorderBottom ? "4px" : "16px",
                        height: "24px",
                        width: "24px",
                        cursor: "pointer",
                        transform: showDetails ? "rotate(90deg)" : "rotate(0deg)",
                        transition: "transform 0.1s ease-in-out"
                    }}
                />
            </Grid>
            <Grid sx={{ marginBottom: showDetails ? "8px" : undefined }} xs={12}>{showDetails && children}</Grid>
        </Grid>
    )
}